import React from 'react';
import { Shimmer, ShimmerPlaceholderText } from '../../../../../ui';
import {
	StyledBookingDetailsCell as Cell,
	StyledBookingDetailsRow as Row,
	StyledBookingDetailsTable as Table,
	StyledBookingDetailsTableBody as TableBody,
} from '../../booking/BookingDetailsTable';

export const BookingDetailsShimmer = () => (
	<div>
		<Shimmer>
			<Table>
				<TableBody>
					<Row>
						<Cell>
							<ShimmerPlaceholderText />
						</Cell>
					</Row>
					<Row>
						<Cell>
							<ShimmerPlaceholderText />
						</Cell>
					</Row>
					<Row>
						<Cell>
							<ShimmerPlaceholderText />
						</Cell>
					</Row>
					<Row>
						<Cell>
							<ShimmerPlaceholderText />
						</Cell>
					</Row>
					<Row>
						<Cell>
							<ShimmerPlaceholderText />
						</Cell>
					</Row>
				</TableBody>
			</Table>
		</Shimmer>
	</div>
);
